import angular from 'angular';
import uiRouter from 'angular-ui-router';
import targetComponent from './target.component';
import targetListComponent from './target-list.component';
import targetCategoryListComponent from './target-category-list.component';
import targetService from './target.service';

let targetModule = angular.module('target', [
  uiRouter
])

.service('Target', targetService)

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/target');

  $stateProvider
    .state('target', {
      component: 'target'
    })
    .state('target.list', {
      url: '/target',
      component: 'targetList',
      params: {
        parent_group_id: 'null'
      }
    })
    .state('target.category', {
      url: '/target/category',
      component: 'targetCategoryList'
    });
})

.component('target', targetComponent)
.component('targetList', targetListComponent)
.component('targetCategoryList', targetCategoryListComponent)

.name;

export default targetModule;



// WEBPACK FOOTER //
// ./client/app/components/target/target.js